import { AudioDeviceInfo, VideoDeviceInfo } from "@azure/communication-calling";
import { Flex, Dropdown, Text } from "@fluentui/react-northstar";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useDeviceSelectDropdownStyles } from "./DeviceSelectDropdown.styles";
import { DeviceSelectDropdownProps } from "./DeviceSelectDropdown.types";

export const DeviceSelectDropdown: React.FC<DeviceSelectDropdownProps> = ({
  deviceList,
  label,
  selectedDevice,
  updateSelectedDevice,
}) => {
  const deviceSelectDropdownStyles = useDeviceSelectDropdownStyles();
  const { t } = useTranslation();
  const defaultDevice = t("DEFAULT_DEVICE");

  const dropdownItems = useMemo(() => {
    return (deviceList ?? []).map(
      (device: AudioDeviceInfo | VideoDeviceInfo) => ({
        "data-itemid": device.id,
        header: device.name,
      })
    );
  }, [deviceList]);

  return (
    <Flex column gap="gap.small">
      <Text
        content={<>{label}</>}
        size="small"
        weight="regular"
        align="start"
      />
      <Dropdown
        data-testid={label}
        fluid
        styles={deviceSelectDropdownStyles.selectDeviceDropdown}
        autoSize
        onChange={updateSelectedDevice}
        defaultValue={selectedDevice?.name ?? defaultDevice}
        items={dropdownItems}
      />
    </Flex>
  );
};
